<input
  type="number"

  step="0.01"

  [formControl]="control"

  (blur)="onBlur()"

  class="kt-input kt-input-sm text-right"
/>

<mat-error
  *ngIf="
    control?.invalid &&
    control?.touched
  ">

  {{ getError() }}

</mat-error>